import React, { useState, useEffect } from "react";
import { documentToHtmlString } from "@contentful/rich-text-html-renderer";
import dayjs from "dayjs";
import { Helmet } from "react-helmet";

import contentfulApi from "../../utils/contentful";

import PageHeader from "../../components/PageHeader";
import Row from "../../components/Row";
import Col from "../../components/Col";
import Container from "../../components/Container";

import Page404 from "../Responses/Page404";

const BlogPost = (props) => {
  const [data, setData] = useState({});
  const [redirect, setRedirect] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);

  useEffect(() => {
    contentfulApi
      .getEntries({
        content_type: "blogPost",
        "fields.slug": props.match.params.slug,
      })
      .then((response) => {
        if (response.items.length === 0) {
          setRedirect(true);
        } else {
          setData(
            Object.assign(response.items[0].fields, {
              createdAt: response.items[0].sys.createdAt,
            })
          );
          setDataLoaded(true);
        }
      });
  }, [props]);

  if (!dataLoaded && redirect) {
    return <Page404 />;
  }

  if (!dataLoaded) {
    return null;
  }

  let options = {
    renderNode: {
      "embedded-asset-block": (node) =>
        `<img class="img-responsive mb-20" src="${node.data.target.fields.file.url}"/>`,
    },
  };

  return (
    <>
      <Helmet>
        <title>{data.title} - Papa - Family On-demand</title>
        <meta
          name="title"
          content={`${data.title} - Papa - Family On-demand`}
        ></meta>
        <meta name="description" content={data.excerpt}></meta>
        {/* <!-- Open Graph / Facebook --> */}
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:url"
          content={`https://www.papa.com/blog/${data.slug}`}
        ></meta>
        <meta
          property="og:title"
          content={`${data.title} - Papa - Family On-demand`}
        ></meta>
        <meta property="og:description" content={data.excerpt}></meta>
        <meta
          property="og:image"
          content="http://papa.com/wp-content/uploads/2017/10/1296x728_10_Things_to_Add_to_Your_Caregiver_Toolkit.jpg"
        ></meta>
        {/* <!-- Twitter --> */}
        <meta property="twitter:card" content="summary_large_image"></meta>
        <meta
          property="twitter:url"
          content={`https://www.papa.com/blog/${data.slug}`}
        ></meta>
        <meta
          property="twitter:title"
          content={`${data.title} - Papa - Family On-demand`}
        ></meta>
        <meta property="twitter:description" content={data.excerpt}></meta>
        <meta
          property="twitter:image"
          content="http://papa.com/wp-content/uploads/2017/10/1296x728_10_Things_to_Add_to_Your_Caregiver_Toolkit.jpg"
        ></meta>
      </Helmet>

      <div className="blog">
        <PageHeader>
          <Row>
            <Col md={12}>
              <h1>Papa Blog</h1>
            </Col>
          </Row>
        </PageHeader>

        <div className="blog__content">
          <Container>
            <div className="text-center">
              <h1>{data.title}</h1>
              <h3 className="date">
                {dayjs(data.createdAt).format("MMMM D, YYYY")}
              </h3>

              <hr />
            </div>

            <div
              dangerouslySetInnerHTML={{
                __html: documentToHtmlString(data.content, options),
              }}
            />
          </Container>
        </div>
      </div>
    </>
  );
};

export default BlogPost;
